<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <v-toolbar-title class="white--text">รายงานคำร้องนักศึกษา</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 
    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md6 d-flex>
            <v-select
              :loading="loadingAcademicYear"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="params.academicYear"
              item-value="id"
              item-text="yearSemester"
              outline
              hide-details
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-text :class="params.reportType === 'A' ? 'green lighten-5' : '' ">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md12 d-flex>
            <v-radio-group v-model="params.reportType" :disabled="params.academicYear === null">
              <strong>
                <v-radio label="สรุปรายละเอียดคำร้องตามประเภท" value="A"></v-radio>
              </strong>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 md6 d-flex offset-xs1 offset-md1>
            <v-select
              :items="requestTypeItems"
              v-model="params.requestType"
              label="ประเภทคำร้อง"
              item-text="name"
              item-value="id"
              outline
              hide-details
              :disabled="params.reportType === 'B' || params.academicYear === null"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text :class="params.reportType === 'B' ? 'green lighten-5' : '' ">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md12 d-flex>
            <v-radio-group v-model="params.reportType" :disabled="params.academicYear === null">
              <strong>
                <v-radio label="สรุปจำนวนคำร้องนักศึกษา" value="B"></v-radio>
              </strong>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          target="_new" 
          :href="printoutUrl"
          v-if="active"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      active: false,
      disabled: true,
      loading: false,
      loadingAcademicYear: false,
      menuFromDate: false,
      menuToDate: false,
      academicYearItems: [],
      params: {
        academicYear: null,
        requestType: null,
        reportType: 'A'
      }
    }
  },
  mounted () {},
  computed: {
    ...mapGetters ({
      token: 'token',
      requestTypeList: 'requestType/requestTypeItems'
    }),
    requestTypeItems () {
      return [{ id: 0, name: 'ทั้งหมด' }, ...this.requestTypeList]
    },
    printoutUrl () {
      return `${config.serverURI}/studentRequests/printout?academicYear=${this.params.academicYear}&requestType=${this.params.requestType}&reportType=${this.params.reportType}&access_token=${this.token}`
    }
  },
  mounted () {
    this.fetchAcademicYears ()
    this.$store.dispatch('requestType/fetchRequestTypes')
    console.log('requestTypeList', this.requestTypeList)
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    fetchAcademicYears () {
      this.loadingAcademicYear = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loadingAcademicYear = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYear = false
        })
    }
  },
  watch: {
    'params': {
      handler (val) {
        if(val.reportType) this.active = false
        if(val.reportType === 'A' && val.requestType !== null) this.active = true
        if(val.reportType === 'B') this.active = true
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/requests/student.vue